"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlaceholderView;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Button = _interopRequireDefault(require("../../Button"));
function PlaceholderView(_ref) {
  var onClick = _ref.onClick,
    text = _ref.text,
    linkText = _ref.linkText,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'round-plus' : _ref$icon,
    children = _ref.children;
  function clickHandler(e) {
    if (e) e.preventDefault();
    if (onClick) {
      onClick(e);
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "placeholder-view"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: icon,
    colorType: "primary",
    size: 72,
    onClick: clickHandler
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "placeholder-view-text"
  }, text && text.length > 0 ? text : '', ' ', linkText && /*#__PURE__*/_react.default.createElement(_Button.default, {
    link: "#",
    onClick: clickHandler
  }, linkText), children));
}